<template>
    <div class="Contact-container">
        <Header backgroundColor="#222733"></Header>
        <div class="Contact-main">
            <p class="Contact-title">联系我们吧</p>
            <p class="Contact-content">大数据正在改变着商业游戏规则，为企业解决传统业务问题带来了变革的机遇，我们的使命是帮助更多企业创造无限商业价值，加速推动互联网大数据的商业变革。</p>
            <div class="features">
                <div class="feature">
                    <img class="feature-img" src="../../public/imgs/icon-c-01.png" alt="">
                    <p class="feature-title">用户画像</p>
                    <p class="feature-remark">打造精准推荐系统，实现千人千面的精准化运营</p>
                </div>
                <div class="feature">
                    <img class="feature-img" src="../../public/imgs/icon-c-02.png" alt="">
                    <p class="feature-title">用户推送</p>
                    <p class="feature-remark">精准推送结合静态标签、动态标签，提高用户转化率</p>
                </div>
                <div class="feature">
                    <img class="feature-img" src="../../public/imgs/icon-c-03.png" alt="">
                    <p class="feature-title">效果优化</p>
                    <p class="feature-remark">大数据锁定目标受众群体一站式推送，标签化精准触达提升点击率</p>
                </div>
            </div>
            <div class="form">
                <p class="form-title">想联系我们?</p>
                <p class="form-remark">您的信息对我们来说非常重要</p>
                <div class="item-input">
                    <img src="../../public/imgs/icon-name.png" alt="">
                    <input type="text" placeholder="您的姓名" v-model="info.name">
                </div>
                <div class="item-input">
                    <img src="../../public/imgs/icon-mail.png" alt="">
                    <input type="text" placeholder="您的邮箱地址" v-model="info.email">
                </div>
                <textarea name="" id="" cols="30" rows="10" placeholder="简单叙述您的需求… …" v-model="info.feedback">

            </textarea>
                <span class="btn-sendMessage" @click="sendMessage">发送留言</span>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import Header from '../components/Header'
    import Footer from '../components/Footer'

    export default {
        name: 'Contact',
        data() {
            return {
                info: {
                    version: '1.0.0_web_bt',
                    name: '',
                    email: '',
                    feedback: '',
                },
                count: 0
            }
        },
        components: {
            Header,Footer
        },
        created() {
            this.$store.commit('changeNavs', 'Contact')
        },
        methods: {
            sendMessage() {
                if(this.count > 0) {
                    this.$message.warning('请勿重复留言!')
                    return false
                }
                const {name,email,feedback} = this.info
                if(!name || !email || !feedback) {
                    this.$message.error('确保信息完整！');
                    return false
                }
                let telReg = /^[\u4e00-\u9fa5 ]{2,20}$/;
                if (!telReg.test(name)) {
                    this.$message.error("姓名格式有误");
                    return false
                }
                let emailReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
                if (!emailReg.test(email)) {
                    this.$message.error("邮箱地址格式有误");
                    return false
                }

                request({
                    url: "/Insurance/user/feedback",
                    data: this.info,
                    method: "POST"
                }).then(response => {
                    console.log(response)
                    if(response.data && response.data.success) {
                        this.count++
                        this.$message.success("发送留言成功!");
                    }
                });
            }
        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" type="text/less">
    .Contact-container {
        position: relative;
        min-width: 1200px;
        /*background-color: #222733;*/
        .Contact-main {
            padding: 120px 0 80px;
            margin-top: -3px;
            background: url('../../public/imgs/bg4.png') no-repeat center center;
            background-size: cover;
            box-sizing: border-box;
            .Contact-title {
                text-align: center;
                font-size: 35px;
                color: #fff;
            }
            .Contact-content {
                color: #fff;
                font-size: 20px;
                text-align: center;
                margin: 25px auto 0;
                width: 1000px;
            }
            .features {
                display: flex;
                justify-content: space-around;
                width: 1000px;
                margin: 60px auto 100px;
                .feature {
                    width: 300px;
                    .feature-img {
                        width: 80px;
                        height: 80px;
                    }
                    .feature-title {
                        color: #fff;
                        font-size: 20px;
                    }
                    .feature-remark {
                        color: #fff;
                        font-size: 16px;
                    }
                }
            }
            .form {
                width: 663px;
                height: 515px;
                margin: 0 auto;
                background:linear-gradient(270deg,rgba(244,245,247,1) 0%,rgba(244,244,247,1) 100%);
                padding: 48px;
                box-sizing: border-box;
                .form-title {
                    font-size: 24px;
                    color: #000;
                    height: 35px;
                    line-height: 35px;
                    margin-bottom: 10px;
                }
                .form-remark {
                    font-size: 16px;
                    color: #525F7F;
                    height: 30px;
                    line-height: 30px;
                    margin-bottom: 40px;
                }
                .item-input {
                    width: 566px;
                    height: 46px;
                    margin: 0 auto 16px;
                    display: flex;
                    align-items: center;
                    background-color: #fff;
                    padding: 0 13px;
                    box-sizing: border-box;
                    border-radius: 3px;
                    box-shadow: 0 0 5px #ddd;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                    input {
                        width: 510px;
                        border: none;
                        outline: none;
                        height: 35px;
                        margin-left: 10px;
                        font-size: 16px;
                    }
                }
                textarea {
                    width: 566px;
                    height: 104px;
                    border: none;
                    padding: 11px;
                    box-sizing: border-box;
                    outline: none;
                    font-size: 16px;
                }
                .btn-sendMessage {
                    width: 556px;
                    height: 51px;
                    text-align: center;
                    line-height: 51px;
                    background-color: #172B4D;
                    display: block;
                    color: #fff;
                    border-radius: 3px;
                    margin-top: 24px;
                    cursor: pointer;
                }
            }
        }
    }
</style>
